import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleContactClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // Navigate to home page with hash
      navigate('/#contact');
      // Wait for page to load, then scroll to contact section
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    } else {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/Aletheia-Icon_100x100_White_72dpi.png" alt="Aletheia Icon" className="footer-icon" />
              <h3>Aletheia</h3>
            </div>
            <p>Healing & Restoration</p>
            <p className="footer-tagline">
              Complete Healing is God's promise. Our mission is to help you experience it.
            </p>
            <p className="footer-nonprofit-status">Aletheia 501(c)(3) &amp; 508(c)(1)(A)</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/mission-vision">Our Mission/Vision</Link></li>
              <li><Link to="/get-involved">Get Involved</Link></li>
              <li><Link to="/services">Services Provided</Link></li>
              <li><Link to="/our-team">Our Team</Link></li>
              <li><Link to="/#contact" onClick={handleContactClick}>Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><Link to="/#contact" onClick={handleContactClick}>Contact Us</Link></li>
              <li><a href="mailto:info@aletheialife.org">info@aletheialife.org</a></li>
              <li><Link to="/get-involved">Partner with Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Aletheia. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

